import FilterPill from '@/components/ui/FilterPill'

type ActiveFilter = { label: string; onRemove: () => void }

export function ActiveFiltersList({ activeFilters }: { activeFilters: ActiveFilter[] }) {
  if (activeFilters.length === 0) return null

  return (
    <div className='flex flex-wrap items-center gap-2'>
      <span className='text-sm text-muted-foreground'>Active filters:</span>
      {activeFilters.map((filter, index) => (
        <FilterPill
          key={index}
          label={filter.label}
          onRemove={filter.onRemove}
          className='border-secondary/20 bg-secondary/10 text-secondary hover:bg-secondary/20'
        />
      ))}
    </div>
  )
}
